import { Routes } from '@angular/router'
import { LayoutComponent } from './layouts/layout/layout.component'
import { Error404Component } from './views/auth/error404/error404.component'
import { Error500Component } from './views/auth/error500/error500.component'
import { MaintenanceComponent } from './views/auth/maintenance/maintenance.component'
import { BlankComponent } from './views/blank/blank.component'
import { authGuard } from './core/guards/auth.guard'
import { companyContextGuard } from './core/guards/company-context.guard'

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'dashboard/analytics',
    pathMatch: 'full',
  },
  {
    path: '',
    component: LayoutComponent,
    canActivate: [authGuard, companyContextGuard],
    loadChildren: () =>
      import('./views/views.route').then((mod) => mod.VIEW_ROUTES),
  },
  {
    path: 'companies',
    component: LayoutComponent,
    canActivate: [authGuard],
    loadChildren: () =>
      import('./views/companies/companies.route').then(
        (mod) => mod.COMPANIES_ROUTES
      ),
  },
  {
    path: 'pages',
    component: LayoutComponent,
    canActivate: [authGuard],
    loadChildren: () => import('./pages/pages.route').then((mod) => mod.PAGES_ROUTES),
  },
  {
    path: 'auth',
    loadChildren: () =>
      import('./views/auth/auth.route').then((mod) => mod.AUTH_ROUTES),
  },
  {
    path: 'not-found',
    component: Error404Component,
    data: { title: '404 - Error' },
  },
  {
    path: 'error-500',
    component: Error500Component,
    data: { title: '500 - Error' },
  },
  {
    path: 'maintenance',
    component: MaintenanceComponent,
    data: { title: 'Maintenance' },
  },
  {
    path: 'merchant',
    redirectTo: 'merchant/pt',
    pathMatch: 'full',
  },
  {
    path: 'merchant/:lang',
    component: BlankComponent,
    data: { title: 'Merchant' },
  },
]
